<template>
  <tk-flex right middle wrap>
    <tk-flex class="page-select" middle>
      第
      <v-select
        v-bind:items="pages"
        v-model="currentPage"
        class="select-wrap"
        autocomplete
      ></v-select>
      页
    </tk-flex>
    <div class="row">
      {{min}}-{{max}} 共 {{total}}
    </div>
    <div>
      <v-btn icon :disabled="page === 1" @click.native="pre"><v-icon>keyboard_arrow_left</v-icon></v-btn>
      <v-btn icon :disabled="page >= totalPage" @click.native="next"><v-icon>keyboard_arrow_right</v-icon></v-btn>
    </div>
  </tk-flex>
</template>

<script>
  export default {
    name: 'pagination',
    data: function () {
      return {
        currentPage: 1
      }
    },
    created () {
      this.currentPage = parseInt(this.page)
    },
    watch: {
      page: function () {
        this.currentPage = parseInt(this.page)
      },
      currentPage: function () {
        this.$emit('pagination', this.currentPage)
      }
    },
    computed: {
      pages: function () {
        let arr = []
        let totalPage = Math.ceil(this.total / this.perPage)
        for (let i = 0; i < totalPage; i++) {
          arr.push(i + 1)
        }
        return arr
      },
      min: function () {
        let min = (this.page - 1) * this.perPage + 1
        return min > this.total ? 0 : min
      },
      max: function () {
        if (this.min === 0) return 0
        let max = this.page * this.perPage
        return max > this.total ? this.total : max
      },
      totalPage: function () {
        return Math.ceil(this.total / this.perPage)
      }
    },
    methods: {
      pre: function () {
        this.$emit('pagination', parseInt(this.page) - 1)
      },
      next: function () {
        this.$emit('pagination', parseInt(this.page) + 1)
      }
    },
    props: {
      page: {
        type: [Number, String],
        default: 1
      },
      perPage: {
        type: Number,
        default: 12
      },
      total: {
        type: [Number, String],
        default: 0
      }
    }
  }
</script>

<style scoped lang="scss">
  .page-select {
    margin-right: 24px;
  }
  .row{
    margin-right: 16px;
  }
  .select-wrap {
    margin-left: 8px;
    margin-right: 8px;
    width: 68px;
  }
</style>



// WEBPACK FOOTER //
// src/admin/components/pagination.vue